import type { FunctionComponent } from 'react';

import { Image } from '@/domains/core/Image/Image';

import DiyAwards from './assets/diy-awards.png';
import OraWinner from './assets/ora-winner.jpg';
import RetailSystems2021 from './assets/retail-systems-awards-2021.png';
import RetailSystems2022 from './assets/retail-systems-awards-2022.png';

export const AwardsBanner: FunctionComponent = () => (
  <>
    <div
      className="flex-flow flex flex-wrap items-center justify-center gap-l
        bg-foundation-inverted p-m"
    >
      <Image
        alt="retail systems awards"
        src={RetailSystems2022}
        width={76}
        height={56}
        data-testid="retailSystemsAwards2022"
      />
      <Image
        alt="diy week awards"
        src={DiyAwards}
        width={125}
        height={56}
        data-testid="diyawards"
      />
      <Image
        alt="ora winner"
        src={OraWinner}
        width={42}
        height={56}
        data-testid="orawinner"
      />
      <Image
        alt="retail systems awards"
        src={RetailSystems2021}
        width={76}
        height={56}
        data-testid="retailSystemsAwards2021"
      />
    </div>
  </>
);

AwardsBanner.displayName = 'AwardsBanner';
